import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Pythonsidebar';

import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Pbreak(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
 
return(
     <div>
<Sides/>
<Helmet>
 
  <title>Learn Free Python Break Beginners Tutorials CodeExampler</title>
<meta name="description" content="Python Break tutorial for beginners.hen a python break is encountered inside any loop, control automatically passes to the first statement after the loop." />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,python break,python break for,python break for loop,,python break line,python break while loop,python break statement,python break continue,python break out of while loop,python break command,python break function,python break two loops,python break all loops" />
<link rel="canonical" href="https://www.codeexampler.com/python-break" />
</Helmet>

<div className='lg:pl-56'>


    <h1 className="m-4 mh1">Python Break Tutorial</h1>
    <div className="first">
        <a href="/python-for-loop">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-continue">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <p className="mt-4 para"> Python break keyword used to exit from loop and switch :<br/>
1, 1, When a python break encounter inside any loop, control automatically passes to the first statement after the loop.<br/>
2, Python break line statement is used to terminate a loop immediately. <br/>
</p>


<h2 className='headings'>Python Break Statement Syntax:</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-7">break</span>
            {"\n"}{"\n"}
                 </code>
        </pre>
        </div> 


<h2 className="mt-4 mh2">python break For Loop Example:</h2>
{/*2 box*/} 



<h2 className='headings'>Q-Write a program Loop starts from 1 to 10, if i=5 so loop Break in Python example?</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
            {"\n"}
            <span className="qwerty-7">for</span>
                 <span className="qwerty-4"> i</span>
                 <span className="qwerty-5"> in</span>
                 <span className="qwerty-6"> range</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-2">1</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-2">11</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
             <span className="qwerty-6">    if</span>
                  <span className="qwerty-4"> i</span>
                  <span className="qwerty">==</span>
                  <span className="qwerty-2">5</span>
                  <span className="qwerty-1">:</span>
              {"\n"}         
                <span className="qwerty-7">        break</span>
                {"\n"}
             <span className="qwerty-3">    print</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-4">i</span>
                  <span className="qwerty-1">)</span>
            {"\n"}{"\n"}
                 </code>
        </pre>
        </div>          
        <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
              <pre style={{maxHeight:"100vh"}}>
                  <code >
                  {"\n"}
                          <span className="qwerty-3">1</span>
                          {"\n"}    
                          <span className="qwerty-3">2</span>
                          {"\n"}    
                          <span className="qwerty-3">3</span>
                          {"\n"}    
                          <span className="qwerty-3">4</span>
                          {"\n"}    
                          {"\n"}    
                </code>
                  </pre>
                  </div> 


<h2 className='headings'>Q-Write a program Loop starts from 1 to 10, but on first even no loop break in Python?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
             <span className="qwerty-7">for</span>
                  <span className="qwerty-4"> i</span>
                  <span className="qwerty-5"> in</span>
                  <span className="qwerty-6"> range</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-2">1</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-2">11</span>
                  <span className="qwerty-1">)</span>
                  <span className="qwerty-1">:</span>
              {"\n"}
              <span className="qwerty-6">    if</span>
                   <span className="qwerty-1"> (</span>
                   <span className="qwerty-4">i</span>
                   <span className="qwerty">%</span>
                   <span className="qwerty-8">2</span>
                   <span className="qwerty">==</span>
                   <span className="qwerty-2">0</span>
                   <span className="qwerty-1">)</span>
                   <span className="qwerty-1">:</span>
               {"\n"}         
                 <span className="qwerty-7">        break</span>
                 {"\n"}
              <span className="qwerty-3">    print</span>
                   <span className="qwerty-1">(</span>
                   <span className="qwerty-4">i</span>
                   <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
               <pre style={{maxHeight:"100vh"}}>
                   <code >
                   {"\n"}
                           <span className="qwerty-3">1</span>
                           {"\n"}    
                           {"\n"}    
                 </code>
                   </pre>
                   </div>  


<h2 className='headings'>Q-Write a program break Program in Python break for loop?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
             <span className="qwerty-7">for</span>
                  <span className="qwerty-4"> i</span>
                  <span className="qwerty-5"> in</span>
                  <span className="qwerty-6"> range</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-2">1</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-2">11</span>
                  <span className="qwerty-1">)</span>
                  <span className="qwerty-1">:</span>
              {"\n"}
              <span className="qwerty-6">    if</span>
                   <span className="qwerty-4"> i</span>
                   <span className="qwerty">==</span>
                   <span className="qwerty-2">4</span>
                   <span className="qwerty-1">:</span>
               {"\n"}
              <span className="qwerty-3">        print</span>
                   <span className="qwerty-1">("</span>
                   <span className="qwerty-10">No 4 is break</span>
                   <span className="qwerty-1">")</span>         
               {"\n"}
                 <span className="qwerty-7">        break</span>
                 {"\n"}
              <span className="qwerty-3">        print</span>
                   <span className="qwerty-1">("</span>
                   <span className="qwerty-10">This is break</span>
                   <span className="qwerty-1">")</span>         
               {"\n"}
              <span className="qwerty-3">    print</span>
                   <span className="qwerty-1">(</span>
                   <span className="qwerty-4">i</span>
                   <span className="qwerty-1">)</span>
                 {"\n"}
              <span className="qwerty-3">print</span>
                   <span className="qwerty-1">("</span>
                   <span className="qwerty-10">Complete</span>
                   <span className="qwerty-1">")</span>         
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
               <pre style={{maxHeight:"100vh"}}>
                   <code >
                   {"\n"}
                           <span className="qwerty-3">1</span>
                           {"\n"}    
                           <span className="qwerty-3">2</span>
                           {"\n"}    
                           <span className="qwerty-3">3</span>
                           {"\n"}    
                           <span className="qwerty-4">No 4 is break</span>
                           {"\n"}    
                           <span className="qwerty-7">Complete</span>
                           {"\n"}    
                           {"\n"}    
                 </code>
                   </pre>
                   </div>  


<h3 className="mt-4 mh3">Break python for loop</h3>



<h2 className='headings'>Q-Write a program to input a no and sum by using for loop but if n==0 so Break in Python?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">sum</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-2">0</span>
             {"\n"}
             <span className="qwerty-7">for</span>
                 <span className="qwerty-4"> i</span>
                 <span className="qwerty-5"> in</span>
                 <span className="qwerty-6"> range</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-2">1</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-2">11</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
             
             <span className="qwerty-4">    n</span>
                  <span className="qwerty-9"> = </span>
                  <span className="qwerty-2">int</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-8">input</span>
                  <span className="qwerty-6">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">Enter a no </span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-6">)</span>
                  <span className="qwerty-1">)</span>
              {"\n"}
                  <span className="qwerty-6">    if</span>
                  <span className="qwerty-4"> n</span>
                  <span className="qwerty">==</span>
                  <span className="qwerty-2">0</span>
                  <span className="qwerty-1">:</span>
              {"\n"}
                  <span className="qwerty-7">        break</span>
              {"\n"}
                  <span className="qwerty-6">    else</span>
                  <span className="qwerty-1"> :</span>
              {"\n"}
                 <span className="qwerty-8">        sum</span>
                 <span className="qwerty-1">=</span>
                 <span className="qwerty-4">sum</span>
                 <span className="qwerty">+</span>
                 <span className="qwerty-2">n</span>
             {"\n"}
                 <span className="qwerty-3">        print</span>
                 <span className="qwerty-1">("</span>
                 <span className="qwerty-10">Sum=</span>
                 <span className="qwerty-5">%d</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-8">%sum</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
             {"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
              <pre style={{maxHeight:"100vh"}}>
                  <code >
                  {"\n"}
                          <span className="qwerty-8">Enter a no : </span>
                          <span className="qwerty-3">42</span>
                          {"\n"}    
                          <span className="qwerty-4">Sum = </span>
                          <span className="qwerty-2">42</span>
                          {"\n"}    
                          <span className="qwerty-8">Enter a no : </span>
                          <span className="qwerty-3">54</span>
                          {"\n"}    
                          <span className="qwerty-4">Sum = </span>
                          <span className="qwerty-2">96</span>
                          {"\n"}    
                          <span className="qwerty-8">Enter a no : </span>
                          <span className="qwerty-3">0</span>
                          {"\n"}    
                          {"\n"}    
                </code>
                  </pre>
                  </div>   


  <h1 className="mt-5">  </h1>

  <div className="back">
        <a href="/python-for-loop">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-continue">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Pbreak;